import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import AcceptInvitation from '../../pages/AcceptInvitation'
import {
  loadInvitation,
  acceptInvitation
} from '../../actions/acceptInvitation'
import { executeRecaptcha } from '../../actions/secureForm'
import { getSiteKey } from '../../selectors/initialization'
import {
  getConfirmationErrorCode,
  getLoadingError,
  getLoaded,
  getConfirmed,
  getName,
  getEmail,
  getIsUserActive
} from '../../selectors/acceptInvitation'
import { getDisabledForm } from '../../selectors/formCommon'

export const mapStateToProps = createSelector(
  [
    getSiteKey,
    getConfirmationErrorCode,
    getLoadingError,
    getLoaded,
    getConfirmed,
    getName,
    getEmail,
    getIsUserActive,
    getDisabledForm
  ],
  (
    siteKey,
    confirmationError,
    loadingError,
    loaded,
    confirmed,
    name,
    email,
    isUserActive,
    disabledForm
  ) => ({
    siteKey,
    confirmationError,
    loadingError,
    loaded,
    confirmed,
    name,
    email,
    isUserActive,
    disabledForm
  })
)

export const mapDispatchToProps = dispatch => ({
  onLoad: ({ invitationToken }) =>
    dispatch(loadInvitation({ invitationToken })),
  onConfirm: ({
    invitationToken,
    password,
    passwordConfirmation,
    recaptchaResponse
  }) =>
    dispatch(
      acceptInvitation({
        invitationToken,
        password,
        passwordConfirmation,
        recaptchaResponse
      })
    ),
  onExecuteRecaptcha: () => dispatch(executeRecaptcha())
})

export default connect(mapStateToProps, mapDispatchToProps)(AcceptInvitation)
